import * as CreDtos from "../CRE.dtos";

export const
    ABOUTUSSETTINGS_REQUEST = "ABOUTUSSETTINGS_REQUEST",
    ABOUTUSSETTINGS_REQUEST_FAILURE = "ABOUTUSSETTINGS_REQUEST_FAILURE",
    ABOUTUSSETTINGS_REQUEST_SUCCESS = "ABOUTUSSETTINGS_REQUEST_SUCCESS",
    ABOUTUSSETTINGS_REQUEST_UPSERT_REQUEST = "ABOUTUSSETTINGS_REQUEST_UPSERT_REQUEST",
    ABOUTUSSETTINGS_REQUEST_UPSERT_REQUEST_FAILURE = "ABOUTUSSETTINGS_REQUEST_UPSERT_REQUEST_FAILURE",
    ABOUTUSSETTINGS_REQUEST_UPSERT_REQUEST_SUCCESS = "ABOUTUSSETTINGS_REQUEST_UPSERT_REQUEST_SUCCESS"

export function aboutUsSettingsRequest() {
    return {
        type: ABOUTUSSETTINGS_REQUEST
    };
}

export function aboutUsSettingsRequestSuccess(aboutUsSettings: CreDtos.AboutUsSettings) {
    return {
        type: ABOUTUSSETTINGS_REQUEST_SUCCESS,
        aboutUsSettings
    };
}

export function aboutUsSettingsRequestFailure(error) {
    return {
        type: ABOUTUSSETTINGS_REQUEST_FAILURE,
        error
    };
}

export function aboutUsSettingsUpsertRequest(aboutUsSettings: CreDtos.AboutUsSettings) {
    return {
        type: ABOUTUSSETTINGS_REQUEST_UPSERT_REQUEST,
        aboutUsSettings
    };
}

export function aboutUsSettingsUpsertRequestSuccess(aboutUsSettings: CreDtos.AboutUsSettings) {
    return {
        type: ABOUTUSSETTINGS_REQUEST_UPSERT_REQUEST_SUCCESS,
        aboutUsSettings
    };
}

export function aboutUsSettingsUpsertRequestFailure(error) {
    return {
        type: ABOUTUSSETTINGS_REQUEST_UPSERT_REQUEST_FAILURE,
        error
    };
}




// WEBPACK FOOTER //
// ./src/actions/aboutUsSettings.actions.ts